<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">
      Account Adjustment (Balance Adjustment)
    </h1>
    <app-navpath />
  </div>
  <div class="content-container">
    <app-data-form [dataFields]="form" (updateFields_child)="updateFields($event)"
      (clickSearch)="fetchContractDetails()" />
    <div class="mt-4 flex w-fit gap-1">
      <button class="shorter-btn save-btn" (click)="update()" [disabled]="lockUpdate">
        <fa-icon [icon]="faSave" class="mr-1" />Update
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
    </div>
  </div>
</section>